import { render, staticRenderFns } from "./posSalesDetailsListTable.vue?vue&type=template&id=7fb61b72&"
import script from "./posSalesDetailsListTable.vue?vue&type=script&lang=js&"
export * from "./posSalesDetailsListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports